/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Flat_Ape_ReadInputs */

const en_happy_flat_ape_read = /** @type {(inputs: Happy_Flat_Ape_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found`)
};

const de_happy_flat_ape_read = /** @type {(inputs: Happy_Flat_Ape_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Keywords gefunden`)
};

/**
* | output |
* | --- |
* | "No keywords found" |
*
* @param {Happy_Flat_Ape_ReadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_flat_ape_read = /** @type {((inputs?: Happy_Flat_Ape_ReadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Flat_Ape_ReadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_flat_ape_read(inputs)
	return de_happy_flat_ape_read(inputs)
});